import { render, staticRenderFns } from "./CertifiedCourse.vue?vue&type=template&id=4167386d&"
import script from "./CertifiedCourse.vue?vue&type=script&lang=js&"
export * from "./CertifiedCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../aristotle-website/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports